'use client';

import { PropsWithChildren } from 'react';
import { LinkClientProps } from './types';
import { storageManager } from '@/services/storage';

const SearchResultsLink = ({ children, clickUrl, addToCartParams, id, ...props }: PropsWithChildren<LinkClientProps>) => {
  const selectCard = async (ev: any) => {
    /**
     * without prevent default items wont be set in storage on safari/firefox
     */
    ev.preventDefault();
    try {
      if (addToCartParams) {
        storageManager.put('addToCartParams', addToCartParams);
      }
      fetch(clickUrl);
    } catch (error) {
      console.error(error);
    } finally {
      window.location.href = props.href as string;
    }
  };

  return (
    <a {...props} onClick={selectCard} data-testid={id ? `search-results-link-${id}` : 'search-results-link'}>
      {children}
    </a>
  );
};

export default SearchResultsLink;
